import { Box, Typography } from '@mui/material';

function KeyActionContent({ keyActionQualification, withHeading = true }) {
	const keyActionFields = Object.keys(keyActionQualification).map((field) => {
		const label = field;
		const value = keyActionQualification[field];

		return (
			<Box key={field} sx={{ display: 'flex', gap: 1, marginBottom: 1 }}>
				<Typography variant="body2" sx={{ fontWeight: 'bold' }}>
					{label}:
				</Typography>
				<Typography variant="body2">{value}</Typography>
			</Box>
		);
	});

	return (
		<Box sx={{ paddingTop: 2, paddingBottom: 2 }}>
			{withHeading && (
				<Typography variant="h6" sx={{ marginBottom: 2 }}>
					Key Action Qualifications
				</Typography>
			)}
			{keyActionFields}
		</Box>
	);
}

export default KeyActionContent;
